<template>
  <div class="seomain">
    <div class="tab-content">
      <div class="st-list-box pan-105">
        <div class="st-list" v-for="(v, k) in stlist" :key="k" :index="k">
          <div class="st-list-top">
            <div class="t-tit">{{ v.code }}</div>
          </div>
          <div class="st-list-main">
            <p>SKU：{{ v.sku }}</p>
            <p>品类：{{ v.cname }}</p>
            <p>品牌：{{ v.brand }}</p>
            <p>型号：{{ v.model }}</p>
            <p>配置：{{ v.deploy }}</p>
            <p>总数：{{ v.purchase_num }}</p>
            <p>已入库：{{ v.storageed }}</p>
            <!-- purchase_num -->
            <p class="red bold">待入库：{{ v.storageing }}</p>
            <p>备注：{{ v.remark }}</p>
            <template v-if="v.storageing != 0 && flag != 'false'">
              <p class="changeType" v-if="v.type == 1" @click="v.type = 2">未找到仓位? 手动添加</p>
              <p class="changeType" v-if="v.type == 2" @click="v.type = 1">返回为级联选择</p>
              <div style="clear: both;"></div>
              <van-field
                v-if="v.type == 1"
                v-model="v.fieldText"
                label="入库仓位"
                placeholder="请选择入库仓位"
                readonly
                @click="
                  activeId = v.purchase_products_id;
                  cascaderShow = true;
                "
              />
              <van-field
                v-if="v.type == 2"
                v-model="v.warehouseText_2"
                label="子仓库"
                placeholder="选择子仓库"
                readonly
                @click="
                  activeId = v.purchase_products_id;
                  pickerShow = true;
                "
              />
              <van-field v-if="v.type == 2" v-model="v.warehouseText_3" label="仓位" placeholder="请输入仓位" />
              <van-field v-model="v.inventoryQuantity" type="tel" label="入库数量" placeholder="请输入入库数量" />
              <van-field v-model="v.loss" type="tel" label="损耗数量" placeholder="请输入损耗数量" />
              <!-- <div class="st-list-bottom" @click="show_detail_box(v.purchase_products_id)" v-if="flag != 'false'"> -->
              <!-- <div class="st-list-bottom" v-if="flag != 'false'">
                <p class="st-opt-btn" @click="submit(v.purchase_products_id)">操 作</p>
              </div> -->
            </template>
          </div>
        </div>
      </div>
    </div>

    <!-- 一键入库 -->
    <div class="footer pf-btm">
      <div class="btn" @click="submit()" v-if="flag != 'false'">
        提交入库表单
      </div>
      <div class="btn" @click="orderShow = true" v-if="flag != 'false'">
        快速入库
      </div>
    </div>

    <!-- 选择 主仓库 子仓库 仓位 -->
    <van-popup v-model="cascaderShow" round position="bottom">
      <van-cascader title="请选择仓库信息" :options="options" @close="cascaderShow = false" @finish="onFinish" />
    </van-popup>
    <!-- 选择 子仓库  -->
    <van-popup v-model="pickerShow" round position="bottom">
      <van-picker
        title="选择子仓库"
        show-toolbar
        :columns="warehousechild"
        @confirm="onConfirm"
        @cancel="pickerShow = false"
      />
    </van-popup>

    <!-- 快速入库提交 -->
    <van-popup
      v-model="orderShow"
      closeable
      round
      position="bottom"
      :style="{ height: '90%', backgroundColor: '#f5f5f5' }"
    >
      <template>
        <van-cell-group>
          <van-field
            v-if="type == 1"
            v-model="orderFrom.position_text"
            label="入库仓位"
            placeholder="请选择入库仓位"
            readonly
            @click="cascaderShow = true"
          />
          <van-field
            v-if="type == 2"
            v-model="orderFrom.warehouseText_2"
            label="子仓库"
            placeholder="选择子仓库"
            readonly
            @click="pickerShow = true"
          />
          <van-field v-if="type == 2" v-model="orderFrom.warehouseText_3" label="仓位" placeholder="请输入仓位" />
          <van-field v-model="orderFrom.stnum" type="tel" label="入库数量" placeholder="请输入入库数量" />
          <p class="changeType" v-if="type == 1" @click="type = 2">未找到仓位? 手动添加</p>
          <p class="changeType" v-if="type == 2" @click="type = 1">返回为级联选择</p>
        </van-cell-group>
      </template>
      <div class="orderSubmit" @click="orderSubmit">快速入库</div>
    </van-popup>
  </div>
</template>

<script>
export default {
  components: {},
  props: {},
  data() {
    return {
      cascaderShow: false,
      cascaderValue: "",
      options: [
        {
          text: "深圳旗丰仓",
          value: "1",
          children: [
            {
              text: "深圳旗丰仓",
              value: "0",
              children: [
                {
                  text: "仓位1",
                  value: "1",
                },
                {
                  text: "仓位2",
                  value: "2",
                },
              ],
            },
            {
              text: "子仓库A",
              value: "1",
              children: [
                {
                  text: "仓位3",
                  value: "3",
                },
                {
                  text: "仓位4",
                  value: "4",
                },
              ],
            },
            {
              text: "子仓库B",
              value: "1",
              children: [
                {
                  text: "仓位5",
                  value: "5",
                },
                {
                  text: "仓位6",
                  value: "6",
                },
              ],
            },
          ],
        },
      ],
      warehousechild: [], // 子仓库选择列表
      pickerShow: false,
      dialog_num: "",
      show: !1,
      stlist: [],
      stinfo: {},
      oneinfo: {},
      paramsid: 0,
      activeId: 0,
      checkid: 0,
      type: 1, // 1 2
      orderFrom: {
        // 整单提交
        id: this.$route.params.id,
        stnum: "", // 数量
        position: "",
        msg: "",
        position: "",
        position_text: "",
        warehouseText_2: "",
        warehouseValue_2: "",
        warehouseText_3: "",
        warehouseValue_3: "",
      },
      orderShow: false,
      fieldText: "",
    };
  },
  watch: {},
  computed: {
    flag() {
      return this.$route.params.flag;
    },
  },
  methods: {
    get_caigou_info: function() {
      let paramsid = this.$route.params.id;
      this.$post(this.$api.stGetCaigouInfo, { id: paramsid }).then((res) => {
        this.stlist = res.data.map((item) => {
          item.type = 1;
          item.fieldValue = "";
          item.fieldText = "";
          item.cascaderValue = "";
          item.warehouseText_2 = "";
          item.warehouseValue_2 = "";
          item.warehouseText_3 = "";
          item.warehouseValue_3 = "";
          item.inventoryQuantity = ""; // 入库数量
          item.loss = 0;
          return item;
        });

        this.stlist = res.data;
        this.options = [res.data[0].position_list];
        this.warehousechild = res.data[0].warehousechild_list;
      });
    },
    // 全部选项选择完毕后，会触发 finish 事件
    onFinish({ selectedOptions }) {
      this.cascaderShow = false;
      let text = selectedOptions.map((option) => option.text).join("/");
      let value = selectedOptions.map((option) => option.value).join("/");
      value = value.substr(value.indexOf("/") + 1);

      if (this.orderShow) {
        // this.orderShow == true 表示正在进行快速入库
        let formObj = this.orderFrom;
        formObj.position = value;
        formObj.position_text = text;
        this.orderFrom = formObj;
      } else {
        this.stlist = this.stlist.filter((item) => {
          if (item.purchase_products_id == this.activeId) {
            item.fieldText = text;
            item.fieldValue = value;
          }
          return item;
        });
      }
    },
    // 确认子仓库的回调
    onConfirm(event) {
      let { text, value } = event;
      this.pickerShow = false;

      if (this.orderShow) {
        // this.orderShow == true 表示正在进行快速入库

        let formObj = this.orderFrom;
        formObj.warehouseValue_2 = value;
        formObj.warehouseText_2 = text;
        this.orderFrom = formObj;
        return;
      }

      this.stlist = this.stlist.filter((item) => {
        if (item.purchase_products_id == this.activeId) {
          item.warehouseText_2 = text;
          item.warehouseValue_2 = value;
        }
        return item;
      });
    },
    /**
     * 过滤掉无效信息
     * @param  dataList
     * @return  是否通过验证
     */
    rulesFromHandle(dataList) {
      let result = dataList.filter((item) => {
        switch (item.type) {
          case 1:
            if (item.fieldValue != "" && item.inventoryQuantity >= 0 && item.loss >= 0) {
              return item;
            }
            break;
          case 2:
            if (
              item.warehouseValue_2 != "" &&
              item.warehouseText_3 != "" &&
              item.inventoryQuantity >= 0 &&
              item.loss >= 0
            ) {
              return item;
            }
            break;
        }
      });
      return result;
    },
    // 提交入库表单
    async submit(id) {
      // 根据id是否存在判断

      let fromData;
      if (id) {
        // 提交单挑数据
        let data = this.rulesFromHandle(this.stlist);
        fromData = data.filter((item) => item.purchase_products_id == id);
        console.log(fromData);
        if (!fromData.length) {
          this.$toast.fail("暂无待入库数量或仓位");
          return;
        }
      } else {
        // 提交全部数据
        fromData = this.rulesFromHandle(this.stlist);
        console.log(fromData);
        if (fromData.length == 0) {
          this.$toast.fail("暂无待入库数量或仓位");
          return;
        }
      }
      let params = [];
      fromData.filter((item) => {
        let obj = {};
        obj.id = item.purchase_products_id;
        obj.stnum = item.inventoryQuantity;
        obj.position = item.fieldValue;
        obj.loss = item.loss;
        if (item.type == 1) {
          obj.msg = item.warehouseValue_2;
        } else if (item.type == 2) {
          obj.msg = item.warehouseValue_2 + "/" + item.warehouseText_3;
        }

        params.push(obj);
      });
      console.log(params);
      let result = await this.$post(this.$api.stGetCaigouAuthIn, params);
      this.$toast.success("提交成功");
      this.get_caigou_info();
    },

    // 根据单号快速入库
    async orderSubmit() {
      let dataFrom = this.orderFrom;
      let msg = "";
      if (this.type == 1) {
        if (dataFrom.position == "" || dataFrom.stnum <= 0) {
          return this.$toast("暂无待入库数量或仓位");
        }
      } else if (this.type == 2) {
        if (dataFrom.warehouseValue_2 == "" || dataFrom.stnum <= 0 || dataFrom.warehouseText_3 == "") {
          return this.$toast("暂无待入库数量或仓位");
        }
        msg = this.type == 1 ? "" : dataFrom.warehouseValue_2 + "/" + dataFrom.warehouseText_3;
      }

      let params = {
        id: dataFrom.id,
        stnum: dataFrom.stnum,
        position: dataFrom.position,
        msg: msg,
      };
      console.log(params);
      let result = await this.$post(this.$api.stGetCaigouoShortcut, params);
      this.$toast.success("操作成功");
      this.orderShow = false;
      this.get_caigou_info();
    },
  },
  created() {
    this.get_caigou_info();
    window.h5sdk.ready(function() {
      window.h5sdk.biz.navigation.setTitle({ title: "采购入库" });
    });
  },
  mounted() {},
};
</script>
<style lang="scss" scoped>
.st-list-top .t-tit {
  height: 20px;
  line-height: 20px;
  margin-top: 8px;
}
.st-list-top .t-check-btn {
  padding: 6px 10px;
  border-radius: 10px;
  color: #fff;
}
.st-list-top .off {
  background: #00baad;
}
.st-list-top .on {
  background: #51596e;
}
.seomain .tab-content {
  box-sizing: border-box;
  padding-bottom: 50px;
}
.footer {
  position: fixed;
  bottom: 0;
  height: 50px;
  box-sizing: border-box;
  padding: 5px 0px;
  width: 100%;
  height: 50px;
  border-top: 1px solid #cccccc;
  background-color: #fff;
}
.seomain .pf-btm {
  display: flex;
}
.seomain .pf-btm .btn {
  flex: 1;
  margin: 0 20px;
  box-sizing: border-box;
  text-align: center;
  line-height: 40px;
  color: #fff;
  border-radius: 11px;
}
.seomain .pf-btm .btn:nth-child(1) {
  background-color: #2a82e4;
}
.seomain .pf-btm .btn:nth-child(2) {
  background-color: #00baad;
}
.van-cell.van-field {
  padding: 10px 0;
}
.changeType {
  margin-top: 20px;
  float: right;
  text-decoration-line: underline;
  color: #2a82e4;
  line-height: 1.5;
}
.van-cell-group {
  padding: 10px;
  padding-top: 50px;
}
.orderSubmit {
  box-sizing: border-box;
  position: absolute;
  bottom: 20px;
  margin: 0 10%;
  width: 80%;
  height: 40px;
  line-height: 40px;
  text-align: center;
  background-color: #00baad;
  color: #fff;
  border-radius: 11px;
  border: none;
}
</style>
